import { MonitoringTags } from '../enums/monitoring-tags.enum';

export const MONITORING_TAG_BY_CIE10: Record<string, MonitoringTags> = {
  'U07.1': MonitoringTags.SEGUIMIENTO_COVID19,
  'U07.2': MonitoringTags.SEGUIMIENTO_COVID19,
  A90: MonitoringTags.DENGUE,
  A91: MonitoringTags.DENGUE
};
